<template>
  <el-dialog title="修改密码" :visible.sync="dialogVisible" width="800px" :mdoal="true" @close="closeDialog"
      :close-on-click-modal="false" center>
      <div>
        <el-form :model="updateFormData" :rules="rulesPassword" ref="ruleFormPassword" label-width="100px">
          <el-form-item prop="old" label="原密码">
            <el-input show-password v-model="updateFormData.old" placeholder="请输入原密码"></el-input>
          </el-form-item>
          <el-form-item prop="newPassword" label="新密码">
            <el-input show-password v-model="updateFormData.newPassword" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item prop="confirmNewPassword" label="确认新密码">
            <el-input show-password v-model="updateFormData.confirmNewPassword" placeholder="请输入确认新密码"></el-input>
          </el-form-item>
        </el-form>
        <!-- <div class="tips">
          备注：密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！
        </div> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="$emit('close')" size="mini">取 消</el-button>
        <el-button type="primary" class="search" size="mini" @click="updatePassword">
          <span>确 定</span>
        </el-button>
      </div>
    </el-dialog>
</template>

<script>
import CryptoJS from "crypto-js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      codeImg: "",
      form: {
        username: "",
        password: "",
        codeKey: "", // 图形验证码key
        psGraphicCode: "" // 密码登录-图形验证码
      },
      key: "u9dYuYlGVk39kkb5",
      prefix: window.location.href, //当前路径
      baseUrl: process.env.VUE_APP_API_DOMAIN + "/tbase-iam-service/iam", //基础路径
      // baseUrl:"/tbase-iam-service/iam", //基础路径
      loginText: "登 录",
      // dialogVisible: false,
      updateFormData: {
        old: "",
        newPassword: "",
        confirmNewPassword: ""
      },
      rulesPassword: {
        // old: [
        //   {
        //     required: true,
        //     message: "请输入原密码",
        //     trigger: "blur",
        //   },
        //   {
        //     // pattern:/^1[3|4|5|7|8][0-9]\d{8}$/,
        //     pattern: "/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,10}$/",
        //     message: "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！",
        //   },
        // ],
        // newPassword: [
        //   {
        //     required: true,
        //     message: "请输入新密码",
        //     trigger: "blur",
        //   },
        //   {
        //     // pattern:/^1[3|4|5|7|8][0-9]\d{8}$/,
        //     pattern: "/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,10}$/",
        //     message: "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！",
        //   },
        // ],
        // confirmNewPassword: [
        //   {
        //     required: true,
        //     message: "请输入确认密码",
        //     trigger: "blur",
        //   },
        //   {
        //     // pattern:/^1[3|4|5|7|8][0-9]\d{8}$/,
        //     pattern: "/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,10}$/",
        //     message: "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！",
        //   },
        // ],
      }
    }
  },
  mounted () {
    if (this.$refs.ruleFormPassword) {
      this.$nextTick(() => {
        this.$refs["ruleFormPassword"].clearValidate();
      });
    }
  },
  methods: {
    encryptByAES(message, key) {
      var iv = "LT0cYheDsyKGHENw";
      var keyHex = CryptoJS.enc.Utf8.parse(key);
      var ivHex = CryptoJS.enc.Utf8.parse(iv);
      var encrypted = CryptoJS.AES.encrypt(message, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    closeDialog() {
      this.formData.old = "";
      this.formData.newPassword = "";
      this.formData.confirmNewPassword = "";
    },
    openDialog() {
      this.dialogVisible = true;
      if (this.$refs.ruleFormPassword) {
        this.$nextTick(() => {
          this.$refs["ruleFormPassword"].clearValidate();
        });
      }
    },
    // 修改密码
    async updatePassword() {
      let xx = true;
      this.$refs["ruleFormPassword"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        // if (this.formData.confirmNewPassword=='' || this.formData.newPassword=='') {
        //   this.$message({
        //   message: '请输入或选择必填项',
        //     type: 'warning'
        //   });
        // }
        return false;
      }
      if (
        this.updateFormData.confirmNewPassword !=
        this.updateFormData.newPassword
      ) {
        this.$message({
          message: "两次密码不一致",
          type: "warning"
        });
        return false;
      }
      let params = {
        newPassword: this.encryptByAES(
          this.updateFormData.newPassword,
          this.key
        ),
        old: this.encryptByAES(this.updateFormData.old, this.key)
      };
      this.$axios
        .post(
          process.env.VUE_APP_API_DOMAIN + "/tbase-iam-manage/user/password",
          params
        )
        .then(res => {
          let result = res.data;
          if (result.code === 200) {
            this.$message({
              type: "success",
              message: "密码修改成功"
            });
            // this.dialogVisible = false;
            this.$emit('close')
          } else {
            this.$message.warning(res.data.msg);
          }
          // const res = await setUserPassword(params);
          // if (res.data.code == 200) {
          //   this.$message({
          //     message: "修改密码成功",
          //     type: "success",
          //   });
          //   this.dialogVisible = false;
          //   // this.login()
          // } else {
          //   this.$message({
          //     message: `${res.data.msg}`,
          //     type: "warning",
        });
      // }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/comp-header/update.vue